import { Box, Fab, Grid, Slider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LeaveTypeCard from './LeaveTypeCard';
import {
  deleteLeaveTypeById,
  getLeaveTypes,
} from '../../../Services/MasterdataService';
import GenericLoader from '../../../../components/Loader/GenericLoader';
import { useDispatch } from 'react-redux';
import {
  LeavesTypesLoaderAttribute,
  SHOW_NOTIFICATION,
  colorOptionsLeaveType,
} from '../../../../constants';
import LeaveTypeForm from './LeaveTypeForm/LeaveTypeForm';
import AddIcon from '@mui/icons-material/Add';
import { DialogBoxComponent } from '../../../../components/DialogBox/DialogBoxCard';

function LeaveTypes() {
  const [loader, setLoader] = React.useState(false);
  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);
  const [leaveTypesList, setleaveTypesList] = React.useState([]);
  const [refresh, setRefresh] = useState(false);
  const [unUsedColor, setUnUsedColor] = useState([]);
  const [open, setOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const loadData = async () => {
    setLoader(true);
    const response = await getLeaveTypes(selectedYear);
    if (response.isError === false) {
      setleaveTypesList(response.data.data);
      setLoader(false);
    } else {
      setLoader(false);
    }
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }
  };

  useEffect(() => {
    loadData();
  }, [selectedYear, refresh]);

  const getUnusedLeaveColor = () => {
    let colors = [];
    for (let i = 0; i < colorOptionsLeaveType.length; i++) {
      const col = colorOptionsLeaveType[i];
      let flag = true;
      for (let j = 0; j < leaveTypesList.length; j++) {
        const element = leaveTypesList[j];
        if (element.color === col.color) {
          flag = false;
          break;
        }
      }
      if (flag) colors.push(col);
    }
    setUnUsedColor(colors);
  };

  useEffect(() => {
    getUnusedLeaveColor();
  }, [leaveTypesList]);

  const deleteLeaveType = async (leaveTypeId) => {
    const response = await deleteLeaveTypeById(leaveTypeId, selectedYear);
    if (response.isError === false) {
      setRefresh(!refresh);
    }
    dipatchNotification(response.type, response.message);
  };

  const ChildGrid = {
    display: '',
    justifyContent: 'center',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    border: '1px solid #ccc',
  };

  const handleSliderChange = (newValue) => {
    setSelectedYear(newValue);
  };

  const sliderContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '125px',
  };

  const yearTextStyle = {
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box className="main-content-overlay" sx={{ pt: '10px' }}>
        <Box>
          <div style={sliderContainerStyle}>
            <div onClick={() => handleSliderChange(2023)} style={yearTextStyle}>
              {currentYear}{' '}
            </div>
            <Slider
              value={selectedYear}
              onChange={(event, newValue) => {
                handleSliderChange(newValue);
              }}
              min={currentYear}
              max={nextYear}
              sx={{ width: '25%' }}
            />
            <div onClick={() => handleSliderChange(2024)} style={yearTextStyle}>
              {nextYear}
            </div>
          </div>
        </Box>
        {loader ? (
          <GenericLoader
            rectAttributes={LeavesTypesLoaderAttribute}
            showError={showError}
            setShowError={setShowError}
          />
        ) : (
          <div>
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={6} style={{ padding: '20px' }}>
                Manager
                <Grid style={ChildGrid}>
                  {leaveTypesList.map(
                    (item) =>
                      item.leaveCategoryId === 1 && (
                        <LeaveTypeCard
                          key={item.id}
                          leaveType={item}
                          refresh={refresh}
                          setRefresh={setRefresh}
                          deleteLeaveType={deleteLeaveType}
                          unUsedColor={unUsedColor}
                          leaveTypesList={leaveTypesList}
                          selectedYear={selectedYear}
                        />
                      ),
                  )}
                </Grid>
              </Grid>
              <Grid item xs={6} style={{ padding: '20px' }}>
                HR
                <Box style={ChildGrid}>
                  {leaveTypesList.map(
                    (item) =>
                      item.leaveCategoryId === 2 && (
                        <LeaveTypeCard
                          key={item.id}
                          leaveType={item}
                          refresh={refresh}
                          setRefresh={setRefresh}
                          deleteLeaveType={deleteLeaveType}
                          unUsedColor={unUsedColor}
                          leaveTypesList={leaveTypesList}
                          selectedYear={selectedYear}
                        />
                      ),
                  )}
                </Box>
              </Grid>
            </Grid>
          </div>
        )}
        <Fab
          color="primary"
          style={{
            right: 40,
            bottom: 50,
            position: 'fixed',
            zIndex: 1051,
            // the zIndex of edit and delete buttons is 1050
          }}
          onClick={() => {
            setOpen(true);
          }}
        >
          <AddIcon />
        </Fab>
        <DialogBoxComponent
          open={open}
          fullWidth={true}
          handleClose={handleClose}
          component={
            <LeaveTypeForm
              type={'create'}
              refresh={refresh}
              setRefresh={setRefresh}
              unUsedColor={unUsedColor}
              leaveTypesList={leaveTypesList}
              handleFormClose={handleClose}
              selectedYear={selectedYear}
              setOpenForm={setOpen}
            />
          }
        />
      </Box>
    </div>
  );
}

export default LeaveTypes;
